import { createMuiTheme } from "@material-ui/core";
import bannerEenf from "./asset/bannerEenf.jpg";
import bannerIcf from "./asset/bannerIcf.jpg";

const THEME = createMuiTheme({
  palette: {
    primary: {
      light: "#009CDE",
      main: "#0057B7",
      dark: "#003865",
    },
    secondary: {
      main: "#FF8674",
      dark: "#FA4616",
    },
    success: {
      main: "#0BDEAB",
      light: "#9DF2DD",
    },
    warning: {
      main: "#DEAC16",
      light: "#EBCD73",
    },
    error: {
      main: "#DE4716",
      light: "#EB9173",
    },
  },

  typography: {
    fontFamily: ["proxima-nova", "sans-serif"].join(","),
  },
});

const PORTAL = [
  {
    title: "EENF",
    subheader: "Escola de Enfermagem",
    icon: "nurse",
    href: "https://eenf.ufal.br",
    image: bannerEenf,
    color: "#0f6c13",
  },
  {
    title: "ICF",
    subheader: "Instituto de Ciências Farmacêuticas",
    icon: "pharmacy",
    href: "https://icf.ufal.br",
    image: bannerIcf,
    color: "#4daf7c",
  },
];

const ICON = {
  nurse:
    "M12,21a.9.9,0,0,1-1-1V19H10a1,1,0,0,1,0-2h1V16a1,1,0,0,1,2,0v1h1a1,1,0,0,1,0,2H13v1A.9.9,0,0,1,12,21Zm2.8-5.2a1.1,1.1,0,0,1-.7-.3,1,1,0,0,1,0-1.4l2.8-2.8a2.9,2.9,0,0,0,0-4.2,2.9,2.9,0,0,0-4.2,0h0a1.2,1.2,0,0,1-1.4,0h0a2.9,2.9,0,0,0-4.2,0,2.9,2.9,0,0,0,0,4.2l2.8,2.8a1,1,0,0,1-1.4,1.4l-4-4a4.8,4.8,0,0,1,0-7A4.7,4.7,0,0,1,8,3a4.7,4.7,0,0,1,3.5,1.5l.5.4.5-.4a4.8,4.8,0,0,1,7,0,4.8,4.8,0,0,1,0,7l-4,4A.9.9,0,0,1,14.8,15.8Z",
  pharmacy:
    "M14.1,15.5a1,1,0,0,0,1.4,0l4-4a4.8,4.8,0,0,0,0-7,4.8,4.8,0,0,0-7,0l-8,8a4.8,4.8,0,0,0,0,7A4.7,4.7,0,0,0,8,21H8a1,1,0,0,0,0-2H8a2.7,2.7,0,0,1-2.1-.9,2.9,2.9,0,0,1,0-4.2l3.3-3.3ZM15,18a.9.9,0,0,1-1,1H13v1a1,1,0,0,1-2,0V19H10a1,1,0,0,1,0-2h1V16a1,1,0,0,1,2,0v1h1A.9.9,0,0,1,15,18Z",
};

export { THEME, PORTAL, ICON };
